/* 
 * Bare essentials needed to run appn namespaces outside authed areas
 */
namespace appn {
    /**
     * A flag indicating if we are in Server debug mode
     */
    export const isDebug: boolean = appn.isDebug;

    /**
     * A flag indicating if we are in Server debug mode
     */
    export const isTestSuiteRequest: boolean = appn.isTestSuiteRequest;

    /**
     * Just an empty Guid... use it or loose it
     */
    export const emptyGuid: string = appn.emptyGuid;

    /**
     * Just an empty String... use it or loose it
     */
    export const emptyString: string = '';

    String.prototype.endsWithIgnoreCase = function(stringToFind: string, dontTrim: boolean): boolean {
        if (dontTrim)
            return this.toLowerCase().endsWith(stringToFind.toLowerCase());

        return this.trim().toLowerCase().endsWith(stringToFind.trim().toLowerCase());
    };
}

interface String {
    endsWithIgnoreCase(stringToFind: string, dontTrim?: boolean): boolean;
}
